<div class="empty-search">
  <div class="empty-search__title">
    <span>{{ 'No results match the current search' | translate }}</span>
  </div>

  <div class="empty-search__hint" translate>Try adjusting your search term.</div>

  <div class="hint-icon"></div>
</div>
